import React from 'react';
import { Button } from '@/components/ui/Button';

export const GradientButton = ({ children, onClick, className = '', ...props }) => {
  return (
    <>
      <style>
        {`
          @keyframes gradientFlow {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          .cta-button {
            background: linear-gradient(
              90deg,
              rgba(37, 99, 235, 1),
              rgba(147, 51, 234, 0.9),
              rgba(236, 72, 153, 0.95)
            );
            background-size: 200% 100%;
            animation: gradientFlow 4s infinite;
            transition: all 0.3s ease;
          }

          .cta-button:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
          }
        `}
      </style>
      <Button 
        className={`w-full text-white cta-button rounded-[6px] ${className}`}
        onClick={onClick}
        {...props}
      >
        {children}
      </Button>
    </>
  );
}; 